module.exports = __webpack_public_path__ + "img/girl.84982582.png";